import { IconChevronDown } from "@tabler/icons-react";
import { MenuItemProps } from "./@types/NavigationTypes";
import { useState } from "react";

export const MenuItem = ({ props }: MenuItemProps) => {
  const [oppened, setOppened] = useState(false);
  const toggleDropdown = () => {
    oppened ? setOppened(false) : setOppened(true);
  };

  const renderDropdownList = () => {
    return props.submenu?.map((i, k) => {
      return <MenuItem key={k} props={i.props} />;
    });
  };

  return (
    <div>
      <div
        className={`menu-item ${props.active}`}
        onClick={() => {
          props.dropdown ? toggleDropdown() : 0;
        }}
      >
        <a
          target={props.openInNewTab ? "_blank" : ""}
          href={props.path ? props.path : "#"}
        >
          <div className="icon">{props.icon ? props.icon : ""}</div>
          <div className="title">{props.title}</div>
          {props.dropdown ? (
            <div className={`arrow ${oppened ? "oppened" : ""}`}>
              <IconChevronDown />
            </div>
          ) : (
            <></>
          )}
        </a>
      </div>
      {props.submenu ? (
        <div className={`menuItem-submenu ${oppened ? "oppened" : ""}`}>
          {renderDropdownList()}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
